import { TContactInfoUz, TPasswordUz } from "@/types/registrationUz.types";
import { isValidPinfl } from "@/utils/pinfl.util";
import * as Yup from "yup";

export const contactInfoSchema: Yup.ObjectSchema<TContactInfoUz> =
  Yup.object().shape({
    firstName: Yup.string()
      .max(40, "validations_value_shorter_than_40_characters")
      .matches(/^[A-Za-z\s]+$/, "validations_only_latin_letters")
      .required("validations_first_name"),
    lastName: Yup.string()
      .max(40, "validations_value_shorter_than_40_characters")
      .matches(/^[A-Za-z\s]+$/, "validations_only_latin_letters")
      .required("validations_lastname_required"),
    email: Yup.string().matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, {
      message: "validations_email_invalid",
      excludeEmptyString: true,
    }),
    phone: Yup.string()
      .required("validations_phone")
      .test(
        "phone-length",
        "validations_phone_must_be_9_digits",
        function (value) {
          if (value.startsWith("+998")) {
            const phoneDigits = value.replace(/^\+998/, "").replace(/\s/g, "");
            return phoneDigits.length === 9;
          } else if (value.startsWith("+995")) {
            const phoneDigits = value.replace(/^\+995/, "").replace(/\s/g, "");
            return phoneDigits.length === 9;
          } else if (value.startsWith("+380")) {
            const phoneDigits = value.replace(/^\+380/, "").replace(/\s/g, "");
            return phoneDigits.length === 9;
          } else if (value.startsWith("+1")) {
            return true;
          }
          return false;
        },
      ),
    checkTerms: Yup.boolean()
      .required("validations_terms_conditions_required")
      .oneOf([true], "validations_terms_conditions_required"),
    promocode: Yup.string(),
  });

export const passwordSchema: Yup.ObjectSchema<TPasswordUz> = Yup.object().shape(
  {
    password: Yup.string()
      .min(6, "validations_value_longer_than_6_characters")
      .max(40, "validations_value_shorter_than_40_characters")
      .required("validations_password_required"),
  },
);

//@ts-ignore
export const documentlInfoSchema: Yup.ObjectSchema<TDocumentInfoUzbekistan> =
  Yup.object().shape({
    pinFl: Yup.string()
      .required("validations_pinfl")
      .matches(/^\d+$/, "validations_pinfl_must_contain_numbers")
      .length(14, "validations_pinfl_must_contain_numbers_length")
      .test("pinfl-checksum", "validations_pinfl_invalid", (value) =>
        !value || value.length !== 14 ? true : isValidPinfl(value),
      ),
    cardId: Yup.string().required("validations_card_id"),
    dateOfBirth: Yup.string().required("validations_date_of_birth"),
    sex: Yup.object()
      .shape({
        id: Yup.boolean().required("validations_gender_required"),
        mainText: Yup.string(),
      })
      .required("validations_gender_required"),
    firstNameCyrillic: Yup.string()
      .max(32, "validations_shorter_than_32_characters")
      .required("validations_first_name"),
    lastNameCyrillic: Yup.string()
      .max(32, "validations_shorter_than_32_characters")
      .required("validations_lastname_required"),
    // phone: Yup.string().required("validations_phone"),
  });

// @ts-ignore
export const addressInfoSchema: Yup.ObjectSchema<TAddressInfoUzbekistan> =
  Yup.object().shape({
    regionId: Yup.object()
      .shape({
        id: Yup.number().required("validations_region_address"),
        mainText: Yup.string(),
      })
      .required(),
    cityId: Yup.object()
      .shape({
        id: Yup.number().required("validations_city"),
        mainText: Yup.string(),
      })
      .required(),
    streetName: Yup.string().required("validations_street_name"),
  });

export const companyInfoSchemaGe = Yup.object().shape({
  id: Yup.string().required("validations_company_id"),
  address: Yup.string().required("validations_address_required"),
  city: Yup.mixed().required("validations_city"),
  firstName: Yup.mixed().required("validations_legal_form"),
  lastName: Yup.string()
    .matches(/^[ა-ჰ\s\-']+$/, "validations_company_name_georgian")
    .required("validations_company_name"),
});
